var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShUsersSolid(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16.16 12.18"
    }, props),
    React.createElement("path", { d: "M2.424 5.22a1.745 1.745 0 000-3.48 1.745 1.745 0 000 3.48zm11.312 0a1.745 1.745 0 10-1.616-1.74 1.683 1.683 0 001.616 1.74zm.808.87h-1.616a1.555 1.555 0 00-1.139.506 3.988 3.988 0 011.9 2.974h1.666a.84.84 0 00.808-.87v-.87a1.683 1.683 0 00-1.619-1.74zm-6.464 0a3.053 3.053 0 000-6.09 3.053 3.053 0 000 6.09zm1.939.87H9.81a3.656 3.656 0 01-3.459 0h-.21a3.027 3.027 0 00-2.909 3.132v.783a1.261 1.261 0 001.212 1.305h7.272a1.261 1.261 0 001.212-1.305v-.783a3.027 3.027 0 00-2.909-3.132zM4.371 6.6a1.555 1.555 0 00-1.139-.506H1.616A1.683 1.683 0 000 7.83v.87a.84.84 0 00.808.87h1.664a4 4 0 011.9-2.974z" })
  );
}

export default SvgShUsersSolid;